import CommentForAnonymous from './CommentForAnonymous';
export default CommentForAnonymous;
//# sourceMappingURL=index.js.map